import { useEffect } from 'react';

/**
 * Podium Chat Widget Hook
 * 
 * CRITICAL HIPAA CONSIDERATIONS:
 * - Podium is NOT HIPAA-compliant by default
 * - DO NOT collect Protected Health Information (PHI) through chat
 * - Use ONLY for: general inquiries, appointment scheduling, directions, hours
 * - For paid plans: Must sign Business Associate Agreement (BAA) with Podium
 * 
 * This hook loads the Podium webchat widget across all pages.
 * Script provided by Katherine (Podium Onboarding Manager) for Mr. Brown.
 */

export const usePodium = () => {
  useEffect(() => {
    console.log('🔵 usePodium hook started');
    
    // Check if script already exists to prevent duplicates
    const existingScript = document.getElementById('podium-widget');
    console.log('🔍 Existing Podium script:', existingScript);
    
    if (existingScript) {
      console.log('✅ Podium script already exists, skipping...');
      return; // Script already loaded
    }

    console.log('📝 Creating new Podium script...');
    
    // Create and configure the Podium script
    const script = document.createElement('script');
    script.id = 'podium-widget';
    script.src = 'https://connect.podium.com/widget.js#ORG_TOKEN=7616134a-6401-4f48-ae26-0d07181d6acb';
    script.defer = true;
    script.setAttribute('data-organization-api-token', '7616134a-6401-4f48-ae26-0d07181d6acb');

    script.onload = () => {
      console.log('✅ Podium script loaded successfully!');
    };
    
    script.onerror = (error) => {
      console.error('❌ Podium script failed to load:', error);
    };

    // Optional: Track chat events (for analytics)
    window.PodiumEventsCallback = (event, properties) => {
      if (event === 'Conversation Started') {
        console.log('Podium chat conversation started');
        
        // Optional: Track with Google Analytics if available
        if (window.gtag) {
          window.gtag('event', 'chat_started', {
            event_category: 'engagement',
            event_label: 'Podium Chat'
          });
        }
      }
    };

    // Append script to body
    document.body.appendChild(script);

    // Cleanup function: Remove script when component unmounts
    return () => {
      const scriptToRemove = document.getElementById('podium-widget');
      if (scriptToRemove && scriptToRemove.parentNode) {
        scriptToRemove.parentNode.removeChild(scriptToRemove);
      }
      
      // Clean up event callback
      if (window.PodiumEventsCallback) {
        delete window.PodiumEventsCallback;
      }
    };
  }, []); // Empty dependency array = run once on mount
};

export default usePodium;